import { ProviderRateTypeEnum } from '../../../../api';
import AllDayIcon from './Icons/allDay';
import CallIcon from './Icons/call';
import DayIcon from './Icons/day';
import NightIcon from './Icons/night';
import { EPresetTime, IPresetMap } from './ShiftPreset.model';

export const SHIFTS_PRESET_MAP: IPresetMap = {
  [ProviderRateTypeEnum.DAY]: {
    label: 'Day shift',
    type: ProviderRateTypeEnum.DAY,
    tooltip:
      'A Day Shift is defined as any shift that occurs during the daytime hours(does not cross mid-night).',
    icon: <DayIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_day_rate',
    timePeriod: EPresetTime.DAYSHIFT,
  },
  [ProviderRateTypeEnum.OVERNIGHT]: {
    label: 'Night shift',
    type: ProviderRateTypeEnum.OVERNIGHT,
    tooltip: 'A Night Shift is defined as any shift that crosses the midnight (00:00) hour.',
    icon: <NightIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_night_rate',
    timePeriod: EPresetTime.NIGHTSHIFT,
  },
  [ProviderRateTypeEnum._24H]: {
    label: '24 hours shift',
    type: ProviderRateTypeEnum._24H,
    tooltip:
      'A 24-hour onsite shift is defined as any shift that requires provider be on hospital property and available for 24 hours.',
    icon: <AllDayIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_24h_rate',
    timePeriod: EPresetTime.FULLDAYSHIFT,
  },
  [ProviderRateTypeEnum.CALL]: {
    label: 'Call Shift',
    type: ProviderRateTypeEnum.CALL,
    tooltip:
      'A Call Shift is defined as any shift that requires provider be available by phone and able to respond to the hospital within 30 minutes.',
    icon: <CallIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_call_rate',
    timePeriod: EPresetTime.CALLSHIFT,
  },
};

export const SHIFT_BOOTSTRAP_COL_NAME = (count: number): number => {
  switch (count) {
    case 1:
      return 12;
    case 2:
      return 6;
    case 3:
      return 4;
    case 4:
      return 3;
    default:
      return 12;
  }
};
